module.exports = __webpack_public_path__ + "img/tk-active.9280e8f9.png";